import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'
import { OrderProduct } from 'modules/orders/types'
import { ApiResponse, PaginatedParams } from 'services/api/types'

type Response = ApiResponse<
  OrderProduct & {
    canBeImported: number
    canBeImportedMessage?: string
  }
>

type OrderProductParams = PaginatedParams & {
  productId: string
  customerId: string
  invoiceTypeId: string
  unityId: string
  cdPedidoReserva?: string
}

const loadOrderProduct = (data: OrderProductParams): Promise<Response> => {
  const { page = 1, limit = 10, productId } = data
  return axios.get(`/orders/products/${productId}`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderProduct(query: OrderProductParams) {
  return useQuery(['orderProduct', query], () => loadOrderProduct(query), {
    enabled:
      !!query.productId &&
      !!query.customerId &&
      !!query.invoiceTypeId &&
      !!query.unityId,
    onError: () =>
      toast.error(`Não foi possível carregar o produto selecionado! `, {
        toastId: 'loadOrderProduct'
      })
  })
}
